import { useGetLocationsList } from "@birdwatch/client";

/**
 * Every market ("location") in the system — the reference set behind the
 * location picker and the vendors-list Location filter.
 *
 * `locations` is the REST v5 name for the `Market` table (same rows, same ids),
 * so items keep the `{ id, key, name, order }` shape callers already read.
 * `take: -1` fetches the whole set in one page (the picker has no pagination),
 * and the reference data is cached for the session.
 */
export const useMarkets = () =>
  useGetLocationsList().sort("order").take(-1).get({
    staleTime: Number.POSITIVE_INFINITY,
    gcTime: Number.POSITIVE_INFINITY,
  });
